/* eslint-disable react/require-default-props */
import React from 'react';
/**
 * TableFilterRow
 *
 * Renders the filter row that sits above the mass-action toolbar (decision 8B / 19).
 * Left: the consumer's FilterBar. Right: Grouped-by Tag + Configure button.
 */
export function TableFilterRow({ filterBar, configureCluster }) {
    return (React.createElement("div", { className: "qmb-ui-table__filter-row" },
        React.createElement("div", { className: "qmb-ui-table__filter-row-start" }, filterBar),
        React.createElement("div", { className: "qmb-ui-table__filter-row-end" }, configureCluster)));
}
